import React from "react";

const Home = () => {
  return (
    <div className="home">
      <div className="quotes">
        <h4 className="quote-1">
          "I just met him, but he seems like a nice enough guy."
        </h4>
        <h4 className="quote-2">
          "James is probably my favourite junior software engineer, and my
          second favourite son."
        </h4>
        <h4 className="quote-3">"Stop asking me for a quote"</h4>
      </div>
      <h3>Hello, and welcome to my site</h3>
      <h4 className="intro">A little about me...</h4>
      <p>
        You appear to have stumbled onto my personal site. Welcome! My name is
        James, and I'm a Junior Software Engineer / Automated QA Engineer based
        in the UK. I bring a positive attitude, hard work ethic, and eagerness
        to improve to everything I do. I’m now looking for a new role where I
        can use my skillset to flex my creative passions while also continuing
        to develop and grow as a software engineer.
      </p>
      <p>
        My current experience includes spending 3 years at YuLife working as an
        Automated QA Engineer and a Web Developer, as well as 6 months working
        at Witekio as a Junior Web Developer. I enjoyed both opportunities and
        learned a lot, but the time has come for the next step in my software
        engineering adventure.
      </p>
      <p>
        But what is any super hero story without a good origin story? Before
        being a software engineer, I spent several years working in the
        television industry as a graphics operator and then manager. It was fun,
        but I found myself wanting something more to satisfy my creative urges.
        I’d always had a passion for technology as well as problem solving, from
        simple games to completing a Rubik’s Cube, and so I left my career and
        enrolled on General Assembly’s intensive software engineering course. It
        was a scary move, but since taking that step, I've never looked back,
        and am keen to keep marching forwards into the crazy world of coding.
      </p>
      <h4>
        Feel free to browse my site for a look at some of the projects I've made
        as well as more information about my background. If you have any
        questions, don't hesitate to get in touch
      </h4>
    </div>
  );
};

export default Home;
